var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useCallback, useContext, useEffect, useState } from "react";
import { AccountContext } from "./context";
import { useFetchAccount } from "./hooks";
export var renderAccountDialog = function (renderer) {
    var _a = useContext(AccountContext), _sdkReady = _a.sdkReady, events = _a.events;
    var sdkReady = _sdkReady;
    var _b = __read(useState(false), 2), loginLoading = _b[0], setLoginLoading = _b[1];
    var _c = __read(useState(0), 2), smsCountDown = _c[0], setSmsCountDown = _c[1];
    var fetchAccount = useFetchAccount();
    var onLoginHandler = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var account;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchAccount()];
                case 1:
                    account = _a.sent();
                    if (account) {
                        events.login.forEach(function (cb) { return cb(account); });
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [events, fetchAccount]);
    var loginByPassword = function (username, password) {
        return __awaiter(this, void 0, void 0, function () {
            var sdk, res, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, sdkReady()];
                    case 1:
                        sdk = _a.sent();
                        setLoginLoading(true);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, sdk.User.loginByPassword(username, password)
                            // TODO V2 refactor
                        ];
                    case 3:
                        res = _a.sent();
                        // TODO V2 refactor
                        if (res.result)
                            onLoginHandler();
                        setLoginLoading(false);
                        return [2 /*return*/, res];
                    case 4:
                        err_1 = _a.sent();
                        setLoginLoading(false);
                        throw err_1;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    var loginByCode = function (username, code) {
        return __awaiter(this, void 0, void 0, function () {
            var sdk, res, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, sdkReady()];
                    case 1:
                        sdk = _a.sent();
                        setLoginLoading(true);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, sdk.User.loginByCode(username, code)
                            // TODO V2 refactor
                        ];
                    case 3:
                        res = _a.sent();
                        // TODO V2 refactor
                        if (res.result)
                            onLoginHandler();
                        setLoginLoading(false);
                        return [2 /*return*/, res];
                    case 4:
                        err_2 = _a.sent();
                        setLoginLoading(false);
                        throw err_2;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    var sendSMS = function (phone) {
        return __awaiter(this, void 0, void 0, function () {
            var sdk, res, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, sdkReady()];
                    case 1:
                        sdk = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, sdk.SMS.getLoginSms(phone)];
                    case 3:
                        res = _a.sent();
                        if (res.result)
                            setSmsCountDown(60);
                        return [2 /*return*/, res];
                    case 4:
                        err_3 = _a.sent();
                        throw err_3;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    useEffect(function () {
        if (smsCountDown > 0) {
            var timer_1 = setTimeout(function () { return setSmsCountDown(function (i) { return --i; }); }, 1000);
            return function () {
                clearTimeout(timer_1);
            };
        }
    }, [smsCountDown]);
    return renderer({
        loading: loginLoading,
        smsCountDown: smsCountDown,
        loginByPassword: loginByPassword,
        loginByCode: loginByCode,
        sendSMS: sendSMS,
        // protocolLinks: {},
    });
};
